export default "__VITE_ASSET__bSOXiKUlWuX2_kcenm7s$Q__"